export const SUPPORT_URL = 'https://support.bumble.com/hc';
export const CONTACT_US_URL = 'https://support.bumble.com/hc/articles/30933835506589';
